import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ConfirmDialogComponent } from '../../../Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../Dialogs/models/confirm-dialog.model';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

@Component({
    selector: 'agpr-prompt-card',
    templateUrl: './prompt-card.component.html',
    styleUrls: ['./prompt-card.component.scss'],
    standalone: false
})
export class PromptCardComponent {
    @Input() id: string;
    @Input() title: string;
    @Input() tooltipInfo: string;
    @Input() disabled: boolean;
    @Input() canEdit: boolean = false;
    @Input() showIcon: boolean = true;

    @Output() editPrompt = new EventEmitter<void>();
    @Output() deletePrompt = new EventEmitter<void>();

    readonly buttonTypes = ButtonTypesEnum;
    constructor(
        public coreDialogService: CoreDialogService,
        public localizationService: LocalizationService,
    ) {}

    edit(): void {
        this.editPrompt.next();
    }

    delete(): void {
        const io: ConfirmDialogModel = {
            inputs: {
                heading: 'Ai.analysis.customInsight.delete',
                message: this.localizationService.transform('Ai.analysis.customInsight.delete.confirm', { name: this.title }),
                alertType: messageSeverityEnum.warning,
                okLabel: 'Core.button.delete',
                id: 'BriefingsDelete'
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    if (confirmed) {
                        this.deletePrompt.next();
                    }
                }
            }
        };
        this.coreDialogService.open(ConfirmDialogComponent, io);
    }
}
